module.exports = __webpack_public_path__ + "img/ghost.09b717f6.png";